// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Radio__pc_only___2uJGa","sp_only":"Radio__sp_only___3Cp39","radio":"Radio__radio___2lVI4"};